import { createAction, createSlice } from "@reduxjs/toolkit";

import type { NapiUser } from "@app/types/napi-types";
import type { SigningMethod } from "@app/types/tracking/account";

import type { CaseReducer, PayloadAction } from "@reduxjs/toolkit";

type User = NapiUser | null;

type LogUserInPayload = {
  user: NapiUser;
  redirect_url?: string;
  sign_in_method?: SigningMethod;
};

const logUserInReducer: CaseReducer<User, PayloadAction<LogUserInPayload>> = (
  _state,
  action
) => action.payload.user;

const updateUserReducer: CaseReducer<User, PayloadAction<NapiUser>> = (
  state,
  action
) => ({ ...state, ...action.payload });

const user = createSlice({
  name: "user",
  initialState: null as User,
  reducers: {
    logUserIn: logUserInReducer,
    updateUser: updateUserReducer
  }
});

export const updateUserError = createAction<any>("updateUserError");
export const { logUserIn, updateUser } = user.actions;
export default user.reducer;
